<template>
    <div class="componentRoot" style="width: 100vw; overflow: hidden;">
        <v-container fluid>
            <v-row>
                <v-col style="position: relative">
                    <img  alt="Hero Banner Image" src="/images/main/bgnw6-1.jpg" :style="{
                        height: imageHeight,
                        'object-position': isMobile ? 'left' : 'top'
                    }" style="
                        width: 100vh; 
                        object-fit: cover; 
                        width: 100%;" />

                    <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
                        :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
                        <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
                        <h1 style="color: white" class="mb-4">{{ $t("aboutMe.bannerTitle") }}</h1>
                        <a href="/aboutme">
                            <v-btn flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                                }}</v-btn>
                        </a><br>
                        <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
                            }}</small>
                    </div>
                </v-col>
            </v-row>


            <WaveVue :color="'rgb(var(--v-theme-background))'" :negative="true"
                :style="{ 'margin-top': isMobile ? '-49px' : '-138px' }" :height="isMobile ? 30 : 120"
                style="z-index: 2; position: relative;" />

        </v-container>
        <v-container :fluid="$vuetify.display && $vuetify.display.width < 1920" class="py-0" :class="{}" style="max-width: 1920px">

            <v-row class="background-background mx-0" :class="{ 'pb-12': isMobile }">
                <v-spacer />
                <v-col :cols="mainCols" :style="{ 'margin-left': marginLeftOffset }" class="text-center px-16">
                    <div>
                        <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.0"
                            width="38" height="78" id="svg3266" fill="rgb(var(--v-theme-primary))">
                            <defs id="defs3268">

                            </defs>
                            <g transform="translate(-179.52329,-460.88577)" id="layer1">
                                <g transform="translate(6,5)" id="g3438">
                                    <g id="g3434">
                                        <path
                                            d="M 179.52329,527.00989 C 183.29516,525.25609 187.2412,523.41339 187.2412,519.46736 C 187.2412,518.2397 186.71506,518.2397 184.43513,518.06432 C 181.89213,517.88894 180.83864,516.22284 180.83864,513.94291 C 180.83864,510.78608 182.8555,509.29535 185.31081,509.29535 C 188.99378,509.29535 191.71338,512.53987 191.71338,517.01205 C 191.71338,520.43316 190.04727,523.93953 187.06582,526.48375 C 185.04896,528.14985 183.38285,528.76368 180.57557,529.55289 L 179.52329,527.00989 z M 195.13327,527.00989 C 198.90393,525.25609 202.84997,523.41339 202.84997,519.46736 C 202.84997,518.2397 202.32383,518.2397 200.0439,518.06432 C 197.50089,517.88894 196.44862,516.22284 196.44862,513.94291 C 196.44862,510.78608 198.46548,509.29535 200.92079,509.29535 C 204.60376,509.29535 207.32214,512.53987 207.32214,517.01205 C 207.32214,520.43316 205.65604,523.93953 202.67459,526.48375 C 200.65772,528.14985 198.99162,528.76368 196.18555,529.55289 L 195.13327,527.00989 z"
                                            id="path3253" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <h2 v-if="!isMobile" class="mb-4"><i>{{ $t("aboutMe.aboutMeQuote") }}</i></h2>
                    <h2 v-else class="mb-4"><i>{{ $t("aboutMe.aboutMeQuote") }}</i></h2>
                    <p>{{ $t("aboutMe.aboutMeQuoteAuthor") }}</p>
                </v-col>
                <v-spacer />
            </v-row>

            <WaveVue :color="'rgb(var(--v-theme-background))'" :height="isMobile ? 30 : 120"
                style="z-index: 2; position: relative" />

            <v-row v-if="!isMobile" class="mx-0 light-background"
                :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                <v-col :cols="imageCols" class="pa-0">
                    <v-img style="height: 100%" cover src="/images/main/bgimg5.jpg" />
                </v-col>
                <v-spacer />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 class="mb-4">{{ $t("aboutMe.meTitle") }}</h2>
                    <p v-html="$t('aboutMe.meText')"></p>
                </v-col>
                <v-spacer />
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img style="height: 100%" cover src="/images/main/bgimg5.jpg" />
                    </v-col>
                </v-row>
                <v-row class="wave-mask pb-16">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 class="mb-4">{{ $t("aboutMe.meTitle") }}</h2>
                        <p v-html="$t('aboutMe.meText')"></p>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row v-if="!isMobile" class="wave-mask mx-0"
                style="margin-top: -70px; z-index: 2 !important; position: relative;" :style="{
                    'flex-direction': isMobile ? 'column-reverse' : 'row'
                }">
                <v-spacer v-if=!isXS />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 class="mb-4">{{ $t("aboutMe.anthropologyTitle") }}</h2>
                    <p v-html="$t('aboutMe.anthropologyText')"></p>
                </v-col>
                <v-spacer v-if=!isXS />
                <v-col :cols="imageCols" class="pa-0">
                    <v-img style="height: 100%" cover src="/images/main/Image5.jpeg" />
                </v-col>
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img style="height: 100%" cover src="/images/main/Image5.jpeg" />
                    </v-col>
                </v-row>
                <v-row class="wave-mask pb-16">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 class="mb-4">{{ $t("aboutMe.anthropologyTitle") }}</h2>
                        <p v-html="$t('aboutMe.anthropologyText')"></p>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row v-if="!isMobile" class="wave-mask mx-0">
                <v-col :cols="imageCols" class="pa-0">
                    <v-img style="height: 100%" cover src="/images/main/bgimg6.jpg" />
                </v-col>
                <v-spacer v-if=!isXS />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 class="mb-4">{{ $t("aboutMe.functionTitle") }}</h2>
                    <p v-html="$t('aboutMe.functionText')"></p>
                </v-col>
                <v-spacer v-if=!isXS />
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img style="height: 100%" cover src="/images/main/bgimg6.jpg" />
                    </v-col>
                </v-row>
                <v-row class="wave-mask pb-16">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 class="mb-4">{{ $t("aboutMe.functionTitle") }}</h2>
                        <p v-html="$t('aboutMe.functionText')"></p>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row v-if="!isMobile" class="lightBackground wave-mask mx-0" style="" :style="{
                'flex-direction': isMobile ? 'column-reverse' : 'row'
            }">
                <v-spacer v-if=!isXS />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 class="mb-4">{{ $t("aboutMe.selfLoveTitle") }}</h2>
                    <p v-html="$t('aboutMe.selfLoveText')"></p>
                </v-col>
                <v-spacer v-if=!isXS />
                <v-col :cols="imageCols" class="pa-0">
                    <v-img style="height: 100%" cover src="/images/main/Image6.jpeg" />
                </v-col>
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img style="height: 100%" cover src="/images/main/Image6.jpeg" />
                    </v-col>
                </v-row>
                <v-row class="wave-mask pb-16">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 class="mb-4">{{ $t("aboutMe.selfLoveTitle") }}</h2>
                        <p v-html="$t('aboutMe.selfLoveText')"></p>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row v-if="!isMobile" class=" wave-mask mx-0" style="margin-top: -80px; z-index: 2 !important; position: relative;">
                <v-col :cols="imageCols" class="pa-0">
                    <v-img style="height: 100%" cover src="/images/main/bgimg7.jpg" />
                </v-col>
                <v-spacer v-if=!isXS />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column; width: fit-content">
                    <h2 class="mb-4">{{ $t("aboutMe.questionTitle") }}</h2>
                    <p v-html="$t('aboutMe.questionText')"></p>
                </v-col>
                <v-spacer v-if=!isXS />
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img style="height: 100%" cover src="/images/main/bgimg7.jpg" />
                    </v-col>
                </v-row>
                <v-row class="wave-mask">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 class="mb-4">{{ $t("aboutMe.questionTitle") }}</h2>
                        <p v-html="$t('aboutMe.questionText')"></p>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <WaveVue :height="isMobile ? 30 : 120" :color="'rgb(var(--v-theme-light))'" :negative="true"
                style="z-index: 5; position: relative; margin-top: -120px;" />

            <v-row  class="lightBackground mx-0" style="padding-top: 128px;">
                <v-spacer />
                <v-col :cols="textCols" :style="{ 'padding': isMobile ? '0px' : '' }">
                    <h2 class="mb-4">{{ $t("aboutMe.confidentialityTitle") }}</h2>
                    <p v-html="$t('aboutMe.confidentialityText')"></p>
                </v-col>
                <v-spacer />

            </v-row>
            <v-row class="lightBackground mx-0" style="padding: 128px 0;">
                <v-spacer />
                <v-col :cols="mainCols">
                    <v-img style="height: 150px" src="/images/main/mitglied_im_gepfadet_schwarz_100.jpg" />
                </v-col>
                <v-spacer />
            </v-row>

            <WaveVue :color="'rgb(var(--v-theme-light))'" :height="isMobile ? 30 : 120"
                style="z-index: 2; position: relative" />
            <v-row class="" :style="{ 'margin-top': isMobile ? '-41px' : '-110px' }">
                <v-col :cols="12">
                    <img style="height: 100%; min-height: 150px; width: 100%; object-fit: cover;" :style="{height: imageHeight}"
                        src="/images/main/Praxis_Freud.jpg" />
                </v-col>
            </v-row>
            <WaveVue :color="'rgb(var(--v-theme-background))'" :height="isMobile ? 30 : 120" :negative="true"
                style="z-index: 5; position: relative; margin-bottom: 160px"
                :style="{ 'margin-top': isMobile ? '-41px' : '-120px' }" />


            <v-row tag="section" aria-labelledby="aboutme-information-1" class="mx-0 seo-information-section"
                style="position: relative; border-radius: 15px;"
                :style="{ padding: isMobile ? '56px 8px' : '88px 16px' }">
                <v-spacer />
                <v-col cols="12" md="10" lg="8" xl="7" class="px-6 px-md-8">
                    <h2 id="aboutme-information-1" class="seo-information-heading mb-6">{{ $t("seoContent.aboutme.section1.title") }}</h2>
                    <p>{{ $t("seoContent.aboutme.section1.paragraph1") }}</p>
                    <p>{{ $t("seoContent.aboutme.section1.paragraph2") }}</p>
                </v-col>
                <v-spacer />
            </v-row>

            <v-row tag="section" aria-labelledby="aboutme-information-2" class="mx-0 seo-information-section"
                style="position: relative; border-radius: 15px;"
                :style="{ padding: isMobile ? '56px 8px' : '88px 16px', backgroundColor: 'rgb(var(--v-theme-light))' }">
                <v-spacer />
                <v-col cols="12" md="10" lg="8" xl="7" class="px-6 px-md-8">
                    <h2 id="aboutme-information-2" class="seo-information-heading mb-6">{{ $t("seoContent.aboutme.section2.title") }}</h2>
                    <p>{{ $t("seoContent.aboutme.section2.paragraph1") }}</p>
                    <p>{{ $t("seoContent.aboutme.section2.paragraph2") }}</p>
                    <!-- Editorial preview only. Enable after the client has reviewed the placeholders. -->
                    <aside v-if="showQualificationDraft" class="seo-qualification-draft">
                        <h3 class="mb-3" style="font-weight: 500;">{{ $t("seoContent.aboutme.qualificationDraft.title") }}</h3>
                        <p>{{ $t("seoContent.aboutme.qualificationDraft.intro") }}</p>
                        <ul class="pl-6 mt-4">
                            <li v-for="index in 4" :key="index">{{ $t("seoContent.aboutme.qualificationDraft.item" + index) }}</li>
                        </ul>
                    </aside>
                    <v-btn href="/kontakt#contactFormId" flat class="primaryButton mt-8 rounded-xl">{{ $t("landing.contactText2") }}</v-btn>
                </v-col>
                <v-spacer />
            </v-row>

        </v-container>
    </div>
</template>



<script>
export default {
    name: "aboutMeComponent",

    data() {
        return {
            // Editorial placeholders are deliberately excluded from the live page.
            // Enable only for a clearly marked client preview.
            showQualificationDraft: true,
        }
    },


    computed: {
        leftAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        rightAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        leftServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "8";
                case "lg":
                    return "8";
                case "xl":
                    return "8";
                case "xxl":
                    return "8";
                default:
                    return "8";
            }
        },
        rightServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "4";
                case "lg":
                    return "4";
                case "xl":
                    return "4";
                case "xxl":
                    return "4";
                default:
                    return "4";
            }
        },
        marginLeftOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "0px";
                case "sm":
                    return "0px";
                case "md":
                    return "50px";
                case "lg":
                    return "100px";
                case "xl":
                    return "50px";
                case "xxl":
                    return "50px";
                default:
                    return "50px";
            }
        },
        imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90%";
                case "sm":
                    return "90%";
                case "md":
                    return "90%";
                case "lg":
                    return "80%";
                case "xl":
                    return "80%";
                case "xxl":
                    return "60%"
                default:
                    return "60%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "10%";
                case "sm":
                    return "10%";
                case "md":
                    return "10%";
                case "lg":
                    return "10%";
                case "xl":
                    return "10%";
                case "xxl":
                    return "15%"
                default:
                    return "15%"
            }
        },
        spacerHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "100px";
                case "sm":
                    return "100px";
                case "md":
                    return "100px";
                case "lg":
                    return "100px";
                case "xl":
                    return "100px";
                case "xxl":
                    return "100px";
                default:
                    return "100px";
            }
        },
        mainCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 7;
                case "lg":
                    return 7;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        imageCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 6;
                case "lg":
                    return 6;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        textCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 10;
                case "sm":
                    return 10;
                case "md":
                    return 5;
                case "lg":
                    return 5;
                case "xl":
                    return 4;
                case "xxl":
                    return 4;
                default:
                    return 3;
            }
        },
        navCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 2;
                case "sm":
                    return "auto";
                case "md":
                    return "auto";
                case "lg":
                    return "auto";
                case "xl":
                    return "auto";
                case "xxl":
                    return "auto";
                default:
                    return "auto";
            }
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        isXS() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return false;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
    },

    methods: {

    }
}

</script>
<style scoped>

/* Additional information follows the existing typography and theme colors. */
.seo-information-heading {
    font-size: 2em;
    font-weight: 500;
    line-height: 1.3;
}
.seo-information-section p {
    line-height: 1.8;
}
.seo-information-section p + p {
    margin-top: 1rem;
}
.seo-information-section a:not(.v-btn) {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.2em;
}
.seo-qualification-draft {
    margin-top: 2rem;
    padding: 1.5rem;
    border: 1px dashed currentColor;
    border-radius: 15px;
}
.seo-qualification-draft li + li {
    margin-top: 0.75rem;
}
</style>
